export default __webpack_public_path__ + "static/tag-do-5-light-bded2104cbc50e5b519cdd913af1897d6f50aa93365e0ffcb88880b70f82f0d7.png";